import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
const exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('VisualExercise', LATEST_SCHEMA_VERSION.VisualExercise);
export default exerciseTypeVersionAdapter;